import React from 'react';
import HeadLayout from "../../components/layout/RootLayout";

const PageChildren = () => (
  <div className="relative w-full flex items-top justify-center min-h-screen bg-gradient-to-r from-colorLa to-colorLa dark:from-colorDa dark:to-colorDb sm:items-center">
    <div className="max-w-6xl mx-auto sm:px-6 lg:px-8">
      <div className="mt-8 overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2">
          <div className="p-6 mr-2 sm:rounded-lg">
            <h1 className="text-4xl sm:text-5xl text-gray-800 dark:text-white font-extrabold tracking-tight">
              Privacy Policy
            </h1>
            <p className="text-lg text-gray-700 dark:text-gray-300 mt-4">
              Our extension is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information.
            </p>
            <h2 className="text-2xl sm:text-3xl text-gray-800 dark:text-white font-bold mt-8">
              Data Collection and Usage
            </h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mt-4">
              Our extension collects information strictly necessary to provide its core functionality. This may include browsing activity, website interactions, or other non-personally identifiable information. All data collected is solely used for the intended purpose of the extension.
            </p>
            <h2 className="text-2xl sm:text-3xl text-gray-800 dark:text-white font-bold mt-8">
              User Consent and Control
            </h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mt-4">
              We do not collect data without your explicit consent. Before any data collection occurs, you will be prompted to agree to this Privacy Policy. You can disable data collection at any time from the extension's settings page.
            </p>
            <h2 className="text-2xl sm:text-3xl text-gray-800 dark:text-white font-bold mt-8">
              Data Storage and Protection
            </h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mt-4">
              All collected data is stored securely and is not shared with third parties. We implement industry-standard security measures to protect your information.
            </p>
            <h2 className="text-2xl sm:text-3xl text-gray-800 dark:text-white font-bold mt-8">
              Contact Us
            </h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mt-4">
              If you have any questions or concerns about this Privacy Policy, please contact us at <span className="text-green-600 font-semibold">leocapone@hotmail.com</span>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const Privacy = () => (
  <div>
    <HeadLayout title="Privacy Policy" description="Privacy Policy for Children's App" keywords="privacy policy, children, data protection">
      <PageChildren />
    </HeadLayout>
  </div>
);

export default Privacy;

